import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '../../config/seo';

interface SEOProps {
  readonly title?: string;
  readonly description?: string;
  readonly path?: string;
  readonly ogImage?: string;
  readonly ogType?: string;
  readonly noIndex?: boolean;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description = SEO_CONFIG.defaultDescription,
  path,
  ogImage = SEO_CONFIG.defaultOgImage,
  ogType = 'website',
  noIndex = false,
}) => {
  const shouldNoIndex = noIndex || !SEO_CONFIG.isProduction;
  const canonicalUrl = path ? `${SEO_CONFIG.siteUrl}${path}` : undefined;
  const absoluteOgImage = ogImage.startsWith('http')
    ? ogImage
    : `${SEO_CONFIG.siteUrl}${ogImage}`;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {shouldNoIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SEO_CONFIG.siteName} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={absoluteOgImage} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:type" content={ogType} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={absoluteOgImage} />
    </Helmet>
  );
};
